import { render, staticRenderFns } from "./stockComments.vue?vue&type=template&id=5f2b2252&"
import script from "./stockComments.vue?vue&type=script&lang=js&"
export * from "./stockComments.vue?vue&type=script&lang=js&"
import style0 from "./stockComments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports